
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  STAFF = 'STAFF',
  DRIVER = 'DRIVER',
  CLIENT = 'CLIENT',
  COMERCIAL = 'COMERCIAL',
  LOGISTICA = 'LOGISTICA',
  MONTAGEM = 'MONTAGEM',
  FINANCEIRO = 'FINANCEIRO',
  OPERACIONAL = 'OPERACIONAL'
}

export enum ExtraItemStatus {
  SOLICITADO_AO_COMERCIAL = 'SOLICITADO_AO_COMERCIAL',
  AGUARDANDO_CONTROLADORIA = 'AGUARDANDO_CONTROLADORIA',
  APROVADO = 'APROVADO',
  REJEITADO = 'REJEITADO',
  EXCLUSAO_PENDENTE = 'EXCLUSAO_PENDENTE'
}

export enum AppVertical {
  EVENTS = 'EVENTS',
  CONSTRUCTION = 'CONSTRUCTION',
  MEDICAL = 'MEDICAL',
  RETAIL = 'RETAIL'
}

export enum OrderStatus {
  PENDENTE = 'PENDENTE',
  AGUARDANDO_FINANCEIRO = 'AGUARDANDO_FINANCEIRO',
  CONFIRMADO = 'CONFIRMADO',
  EM_CARREGAMENTO = 'EM_CARREGAMENTO',
  EM_ROTA = 'EM_ROTA',
  MONTAGEM = 'MONTAGEM',
  PROBLEMA = 'PROBLEMA',
  CONCLUIDO = 'CONCLUIDO',
  CANCELADO = 'CANCELADO'
}

export enum ProductType {
  ASSET = 'ATIVO',
  CONSUMABLE = 'INSUMO'
}

export enum ExpenseStatus {
  PENDENTE_APROVACAO = 'PENDENTE_APROVACAO',
  APROVADO = 'APROVADO',
  REJEITADO = 'REJEITADO',
  EXCLUSAO_PENDENTE = 'EXCLUSAO_PENDENTE'
}

export enum DriverPaymentType {
  DIARIA = 'DIÁRIA',
  REEMBOLSO = 'REEMBOLSO',
  SALARIO_SEMANAL = 'SALÁRIO SEMANAL',
  SALARIO_QUINZENAL = 'SALÁRIO QUINZENAL',
  SALARIO_MENSAL = 'SALÁRIO MENSAL',
  ADICIONAL = 'ADICIONAL EXTRA'
}

export interface ExtraItem {
  id: string;
  company_id?: string;
  orderId: string;
  description: string;
  qty: number;
  value: number;
  date: string;
  status: ExtraItemStatus;
  requestedBy: string;
  userId?: string;
}

export interface AppNotification {
  id: string;
  company_id?: string;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'error' | 'success';
  timestamp: string;
  read: boolean;
  orderId?: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  password?: string;
  role: UserRole;
  active: boolean;
  createdAt: string;
  teamId?: string;
  avatar?: string;
  companyId?: string;
  authorizedTabs?: string[];
  cnhPhoto?: string;
  soundEnabled?: boolean;
  companyVertical?: AppVertical;
}

export interface Order {
  id: string;
  company_id?: string;
  clientId: string;
  teamId?: string;
  nomeEvento: string;
  dataEvento: string;
  diasMontagem: string[];
  diaRetirada: string;
  horarioEntrega: string;
  horarioRetirada: string;
  responsavelInterno: string; 
  status: OrderStatus;
  prioridade: Priority;
  origem?: 'MANUAL' | 'CRM';
  valorTaxaDeslocamento: number;
  taxaAplicada: boolean;
  motivoTaxa?: string;
  termoTaxaAceito: boolean;
  termoTaxaAceitoEm?: string;
  createdAt: string;
  updatedAt: string;
  materials: MaterialItem[];
  estimatedCost: number;
  actualCost?: number;
  placa?: string;
  veiculoModelo?: string;
  expenses?: EventExpense[];
  extraItems?: ExtraItem[];
  signature?: string;
  vendedorName?: string;
  validadeProposta?: string;
  eventPhoto?: string;
  estimateId?: string;
}

export interface EventExpense {
  id: string;
  orderId: string;
  company_id: string; 
  description: string;
  amount: number;
  category: 'LOGISTICA' | 'PESSOAL' | 'MANUTENCAO' | 'OUTROS';
  date: string;
  status?: ExpenseStatus;
  requestedBy?: string;
  photo?: string;
  userId?: string;
}

export interface SalesGoal {
  id: string;
  company_id?: string;
  month: string;
  year: number;
  targetValue: number;
  currentValue: number;
  status: 'ACTIVE' | 'COMPLETED' | 'FAILED';
}

export interface Product {
  id: string;
  company_id?: string;
  name: string;
  quantity: number;
  quantityMaintenance: number;
  unitPrice: number; 
  color: string;
  category: string;
  sku: string;
  image?: string;
  lastUpdated: string;
  type?: ProductType;
}

export interface Team {
  id: string;
  company_id?: string;
  name: string;
  leaderId: string;
  members: string[];
}

export interface Client {
  id: string;
  company_id?: string;
  empresa: string;           
  contatoResponsavel: string; 
  nomeLocal: string;         
  cep: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
  emailContato: string;
  telefonePrincipal: string;
  enderecoCompleto: string;
  logo?: string;
  cnpj_cpf?: string;
  inscricao_estadual?: string;
  segmento?: string;
  website?: string;
  observacoes?: string;
}

export interface MaterialItem {
  id: string | number;
  name: string;
  qty: number;
  checked: boolean;
  damaged?: boolean;
  costPerUnit?: number;
  isConsumable?: boolean;
  medida?: string;
}

export enum Priority {
  BAIXA = 'BAIXA',
  MEDIA = 'MEDIA',
  ALTA = 'ALTA',
  URGENTE = 'URGENTE'
}

export interface Company {
  id: string;
  name: string;
  cnpj: string;
  address: string;
  neighborhood: string;
  city: string;
  state: string;
  zip?: string;
  managerName: string;
  contactEmail: string;
  whatsapp: string;
  plan: 'START' | 'PRO' | 'ENTERPRISE';
  vertical: AppVertical;
  status: 'ACTIVE' | 'TRIAL' | 'PAST_DUE';
  mrr: number;
  payable: number;
  receivable: number;
  activeOrders: number;
  usersCount: number;
  lastSync: string;
  licenseExpiry?: string;
  nfseEnabled: boolean;
  blocked: boolean; 
  iaUsageCount: number;
  equityValue: number; 
  logo?: string;
  policy?: string;
}

export interface Plan {
  id: string;
  name: string;
  subtitle: string;
  price: number;
  setup: number;
  features: string[];
  popular?: boolean;
  btnColor: string;
  maxItems: number; 
  maxUsers: number;
  maxDrivers: number;
}

export enum LeadStatus {
  NEW = 'lead-novo',
  PROPOSTA = 'proposta',
  NEGOCIACAO = 'em-negociacao',
  CUSTOMER = 'cliente',
  LOST = 'perdido'
}

export interface Lead {
  id: string;
  company_id?: string;
  name: string;
  company: string;
  phone: string;
  email: string;
  value: number;
  status: string | LeadStatus;
  assignedTo: string;
  tags: string[];
  source: string;
  lastContact: string;
  createdAt: string;
  cep: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  followUpDate?: string;
  description?: string;
  cnpj?: string;
  cpf?: string;
}

export interface DriverPayment {
  id: string;
  company_id?: string;
  userId: string;
  type: DriverPaymentType;
  amount: number;
  date: string;
  description: string;
  status: string;
}

export enum ContractStatus {
  ATIVO = 'ATIVO',
  EXPIRADO = 'EXPIRADO',
  CANCELADO = 'CANCELADO'
}

export interface Contract {
  id: string;
  company_id?: string;
  clientId: string;
  subject: string;
  value: number;
  type: string;
  startDate: string;
  endDate: string;
  description: string;
  isTrash: boolean;
  hideFromClient: boolean;
  status: ContractStatus;
  projectName?: string;
}

export enum ProjectStatus {
  NAO_INICIADO = 'NÃO INICIADO',
  EM_PROGRESSO = 'EM PROGRESSO',
  AGUARDANDO = 'AGUARDANDO',
  CANCELADO = 'CANCELADO',
  CONCLUIDO = 'CONCLUÍDO'
}

export enum TaskStatus {
  NAO_INICIADO = 'NÃO INICIADO',
  EM_PROGRESSO = 'EM PROGRESSO',
  AGUARDANDO = 'AGUARDANDO',
  CONCLUIDO = 'CONCLUÍDO',
  CANCELADO = 'CANCELADO'
}

export interface Task {
  id: string;
  company_id?: string;
  projectId: string;
  name: string;
  description: string;
  status: TaskStatus;
  priority: Priority;
  startDate?: string;
  deadline?: string;
  assignedTo: string[];
  tags: string[];
  createdAt: string;
}

export interface Project {
  id: string;
  company_id?: string;
  name: string;
  clientId: string;
  status: ProjectStatus;
  progress: number;
  calculateProgressByTasks: boolean;
  billingType: string;
  estimatedHours: string;
  startDate: string;
  deadline: string;
  tags: string[];
  members: string[];
  description: string;
  sendEmailOnCreate: boolean;
  contactNotificationType: string;
  visibleTabs: string[];
  permissions: any;
}

export enum EstimateStatus {
  RASCUNHO = 'RASCUNHO',
  ENVIADO = 'ENVIADO',
  EXPIRADO = 'EXPIRADO',
  DECLINADO = 'DECLINADO',
  ACEITO = 'ACEITO'
}

export interface EstimateItem {
  id: string;
  company_id?: string;
  name: string;
  description: string;
  longDescription: string;
  qty: number;
  rate: number;
  tax: number;
  amount: number;
}

export interface Estimate {
  id: string;
  company_id?: string;
  number: string;
  clientId: string;
  date: string;
  expiryDate: string;
  status: EstimateStatus;
  total: number;
  subTotal: number;
  adjustment: number;
  items: EstimateItem[];
  assemblyDate?: string;
  removalDate?: string;
  currency?: string;
  reference?: string;
  saleAgent?: string;
  discountType?: string;
  adminNote?: string;
  clientNote?: string;
  termsConditions?: string;
  tags?: string[];
  hasThirdPartyMaterials?: boolean;
  thirdPartyMaterialsNote?: string;
}

export enum InvoiceStatus {
  AGUARDANDO_FINANCEIRO = 'AGUARDANDO_FINANCEIRO',
  A_FATURAR = 'A_FATURAR',
  FATURADO = 'FATURADO',
  CANCELADO = 'CANCELADO'
}

export interface Invoice {
  id: string;
  company_id?: string;
  number: string;
  clientId: string;
  clientName: string;
  date: string;
  dueDate: string;
  total: number;
  status: string | InvoiceStatus;
  items: any[];
}

export interface FixedExpense {
  id: string;
  company_id?: string;
  description: string;
  amount: number;
  dueDay: number;
  category: string;
  startDate: string;
  endDate?: string;
  status: 'ACTIVE' | 'INACTIVE';
  createdAt: string;
}

export interface Payment {
  id: string;
  company_id?: string;
  paymentNum: string;
  invoiceNum?: string;
  method: string;
  transactionId?: string;
  clientName: string;
  amount: number;
  date: string;
  status: 'PENDING' | 'PAID';
  description?: string;
  createdAt: string;
}
